import { Link } from 'react-router-dom'
import { Button, Comment, List, Tag, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { moment } from '@BUP/configs/i18n'
import { EyeOutlined } from '@ant-design/icons'
import { ComplaintInfractionLevelTag } from '@BUP/components/complaint/infraction-level-tag.jsx'
import { ComplaintStateBadgeRibbon } from '@BUP/components/complaint/state-ribbon.jsx'

function ComplaintListItem ({ complaint }) {
  const i18n = useTranslation()
  const showLink = (
    <Link key='show' to={`/logbook/complaints/${complaint.id}`}>
      <Button type='link' icon={<EyeOutlined />}>{i18n.t('common.resources.complaint.actions.show.label')}</Button>
    </Link>
  )
  return (
    <List.Item>
      <ComplaintStateBadgeRibbon state={complaint.state}>
        <Comment
          avatar={<ComplaintInfractionLevelTag level={complaint.infractionLevel} />}
          author={complaint.creator.user.name}
          datetime={moment(complaint.createdAt).fromNow()}
          content={
            <>
              <Typography.Title level={5}>{complaint.title}</Typography.Title>
              <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>{complaint.description}</Typography.Paragraph>
              <Tag key='entries'>{i18n.t('common.resources.complaint-entry.label', { context: 'with-count', count: complaint.complaintEntries.length })}</Tag>
            </>
          }
          actions={[showLink]}
        />
      </ComplaintStateBadgeRibbon>
    </List.Item>
  )
}

export function ComplaintList ({ complaints, ...props }) {
  return (
    <List
      itemLayout='vertical'
      {...props}
      dataSource={complaints}
      renderItem={complaint => <ComplaintListItem key={complaint.id} complaint={complaint} />}
    />
  )
}
